import * as Sentry from '@sentry/node';
import {
  GetServerSideProps,
  InferGetServerSidePropsType,
  NextPage,
} from 'next';
import React from 'react';

import PageHandler from '@jpp/shared/PageHandler';
import FAQs from '@jpp/templates/FAQs';
import { IPageStoreState } from 'common/redux/page/reducer';
import { EPageType } from 'common/typings/enums';
import { TReduxError } from 'common/typings/types';
import axios from 'common/utils/axios/internal';

interface IFaqsPageProps {
  error?: TReduxError;
  page: IPageStoreState;
  faqs: any[];
}

type TFaqsPage = IFaqsPageProps &
  InferGetServerSidePropsType<typeof getServerSideProps>;

const FaqsPage: NextPage<TFaqsPage> = ({ page, faqs, error }) => {
  return (
    <PageHandler
      page={{
        ...page,
        faqs,
      }}
      error={error}
      pageType={EPageType.Faqs}
      template={FAQs}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { data: faqsPage } = await axios
    .get(`/page/${EPageType.Faqs}`)
    .catch((e) => {
      Sentry.captureException(e);
      return {
        data: {
          title: 'Frequently Asked Questions',
        },
      };
    });

  try {
    const { data } = await axios.get('/faqs');
    return {
      props: {
        page: faqsPage,
        ...data,
      },
    };
  } catch (e) {
    Sentry.captureException(e);
    return {
      props: {
        page: faqsPage,
        faqs: [],
      },
    };
  }
};

export default FaqsPage;
